export default {
    404: "Помилка 404!! Сторінка не доступна.",
    title_404: "Сторінка, на яку ви намагаєтесь потрапити, недоступна",
    btn_404: "Назад",
    profilePosition: "Користувач",
    manageScreenQuestion: "Питання",
    manageScreenLocation: "Опис місця",
    manageSetAsset: "Ідентифікатор",
    manageSetGeolocation: "Встановити геолокацію",
    manageGeolocation: "Геолокація",
    manageUpdateBtn: "Оновити",
    manageLatitude: "Широта",
    manageLongitude: "Довгота",
    manageGPSAccuracy: "Точність GPS {v1}м",
    manageGPSLocation: "Місцезнаходження GPS",
    manageGPSAllowText: "Будь ласка, дозвольте air-vote.com отримувати дані про місцезнаходження GPS з вашого телефону",
    manageGPSAllowSubtitle: "ми використовуватимемо дані лише тоді, коли ви відвідаєте цю сторінку, щоб оновити геолокацію стікеру",
    manageGPSPopupLongDistance: "Ваші поточні координати GPS далекі від попереднього розміщення стікеру ({v1}м)",
    manageGPSPopupBadAccuracyAndLongDistance: "Ваші поточні координати GPS далекі від попереднього розміщення стікеру ({v1}м) та мають низьку точність ({v2}м)",
    manageGPSPopupBadAccuracy: "Поточні координати GPS мають низьку точність ({v1}м)",
    manageGPSPopupSureNewCoords: "Ви впевнені, що хочете застосувати нові координати?",
    manageGPSPopupUseNewCoordsBtn: "Використовуйте нові координати",
    manageGPSPopupChangeManuallyBtn: "Змінити вручну",
    manageMapBtn: "Використати цю локацію",
    manageSaved: "Збережено",
    manageCopiedToClipboard: "Скопійовано в буфер обміну",
    manageGPSUnableToFetchMsg: "Ми не змогли отримати ваше місцезнаходження. Будь ласка, спробуйте ще раз",
    manageGPSUnavailable: "GPS дані недоступні. Будь ласка, перевірте ваші налаштування та спробуйте пізніше",
    manage_back_to_yard: "Back to yard",
    admin_RemoveItem: "Видалити {v1}",
    admin_AddItem: "Додати {v1}",
    admin_Admin: "Адміністратор",
    admin_Owner: "Контакт",
    admin_Client: "Клiєнт",
    admin_Votes: "Відгуки",
    admin_Profiles: "Профілі",
    admin_Organizations: "Організації",
    admin_showAllPlaces: "Показати всі місця",
    admin_SaveRole: "Зберегти роль",
    admin_deleteRole: "Ви впевнені, що хочете видалити профіль {v1} {v2} ?",
    admin_deleteVote: "Ви впевнені, що хочете видалити відгук до запитання \"{v1}\"",
    admin_deletePlace: "Ви впевнені, що хочете видалити місце \"{v1}\" ?",
    admin_deleteOrganization: "Ви впевнені, що хочете видалити організацію \"{v1}\" ?",
    admin_deletePlaceWarning: "** Зверніть увагу, що всі пов`язані голоси будуть видалені **",
    admin_successMessageAddOwner: "Контакт доданий",
    admin_successMessageAddPlace: "Місце додано",
    admin_successMessageRemoveOwner: "Власник видалений",
    admin_successMessageRemovePlace: "Місце видалено",
    admin_successMessageRemoveVote: "Відгук видалений",
    admin_successMessageRemoveOrganization: "Організація видалена",
    admin_successMessageSaveOrganization: "Організація збережена",
    admin_successMessageChangeRole: "Роль змінено",
    admin_Stickers: "Стікери",
    admin_ChangeStatusToCancelled: "Змінити статус на \"Скасовано\"?",
    admin_ChangeStatusToSent: "Змінити статус на \"Відправлений\"?",
    admin_ChangeStatusToCompleted: "Змінити статус на \"Виконано\"?",
    admin_adminVotesShowAll: "Включно з нашими",
    admin_searchByName: "Пошук по імені",
    admin_signInAs: "Увійти як: {v1}?",
    admin_ReturnToOriginalAccount: "Повернутися до початкового аккаунту: {v1}?",
    admin_closeAccountRequests: "Запити на закриття акаунта",
    admin_landingQuestions: "Питання на сайті",
    admin_firstName: "Ім'я",
    admin_lastName: "Прізвище",
    admin_contactEmail: "Контактний email",
    admin_phone: "Номер",
    admin_success: "Успіх",
    admin_userCreated: "Створено нового юзера",
    admin_sortBy: "Сортувати за",
    admin_sortByName: "Назвою",
    admin_sortByAdded: "Додаванням",
    admin_sortByUpdated: "Оновленням",
    admin_sortByEmail: "Поштою",
    admin_sortByCreated: "Створеням",
    adminPanel: "Адмін панель",
    admin_Add: "Додати",
    admin_Places: "Місця",
    admin_UnQuestions: "Питання",
    admin_ChooseYourPlace: "Виберіть Ваше Місце",
    admin_NothingFound: "Нічого не знайдено",
    admin_Delete: "Видалити",
    admin_delete_image: "Ви хочете видалити зображення?",
    admin_successImageDelete: "",
    Track_vote: "Слідкуйте за Вашими оцінками",
    Logout: "Вихід",
    Sync_status: "Статус синхронізації",
    Success: "Успішно",
    Error: "Помилка",
    Back: "Назад",
    Thank_for_vote: "Дякуємо за Ваш відгук. Бажаєте подивитися Ваші оцінки? Увійдіть за допомогою",
    No_votes: "У вас ще немає відгуків",
    statusMessage: "Зачекайте Будь ласка...",
    Save: "Зберегти",
    ResetChanges: "Скинути зміни",
    sign_in_to_connect: "Будь ласка, увійдіть, щоб підключити цей QR-код до Вашої компанії",
    yes: "Так",
    no: "Ні",
    YourVotes: "Ваші відгуки",
    OtherVotes: "Відгуки інших користувачів",
    AirVotes: "Всього відгуків",
    Change: "Змінити",
    Submit: "Надіслати",
    Cancel: "Скасувати",
    CancelRequest: "Запит був скасований",
    ChangedYourMind: "Передумали? Змініть свій відгук!",
    NotConnectedPlaceToAirVote: "Наразі це місце не підключено до AirVote",
    From: "Від",
    To: "Дo",
    writeFeedBack: "Залишити відгук (опціонально)",
    voteSuccessText_1: "Дякуємо! Ваш відгук надіслано!",
    voteSuccessText_2: "Бажаєте змінити відгук? Натисніть на інший смайлик.",
    voteSuccessText_3: "Є що сказати? Можете залишити коментар",
    feedbackTitle: "Залиште свій коментар",
    feedbackTitleSoSo: "Що треба покращити?",
    feedbackTitleSad: "Підкажіть, що не так?",
    feedbackSubtitle: "Тільки менеджери бізнесу побачать його",
    yourNote: "Ваш коментар",
    commentPopupEmail: "Введіть номер телефону або email",
    feedbackText: "Я хотів би, щоб зі мною зв’язались",
    feedbackHelpText: "Власник компанії отримає його, щоб зв’язатися з вами",
    writeAReview: "Публічний відгук",
    writeAReviewTitle: "Ви можете залишити відгук для {v1} тут:",
    bflow_BusinesConnectQuestion: "Будь ласка, виберіть свій бізнес для підключення питання \"{v1}\"",
    bflow_BusinesConnectQuestionSuccess: "Запитання прив'язане успішно",
    bflow_ChoosePlace: "Будь ласка, виберіть місце для підключення питання \"{v1}\"",
    bflow_AddQuestionSuccess: "Питання було успішно додано",
    bflow_BecameOwnerPlace: "Вітаємо! Ви тільки що стали контактом для \"{v1}\"",
    bflow_BecameOwnerPlaceConfirm: "Ви впевнені, що хочете стати контактом для \"{v1}\" ?",
    bflow_ConfirmConnectQuestionToPlace: "Ви впевнені, що хочете додати питання \"{v1}\" до закладу \"{v2}\" ?",
    bflow_ConfirmConnectQuestionToPlacebelow: "Ви впевнені, що хочете додати питання \"{v1}\" до закладу, зазаначеному нижче?",
    bflow_ConnectedQuestion: "Прив`язка питання",
    bflow_finishBusinesFlow: "Ви впевнені, що хочете вийти?",
    bi_Name: "Ім'я",
    bi_OfficialName: "Назва огранізації",
    bi_ContactEmail: "Електронна пошта",
    bi_Phone: "Телефон",
    bi_Password: "Пароль",
    bi_Edit: "Редагувати",
    bi_Address: "Адреса",
    bi_WebsiteUrl: "Вебсайт",
    bi_validation_OrganizationRequired: "Поле Назва організації обов`язкове для заповнення",
    bi_validation_Email: "Некоректний формат email",
    bi_validation_Phone: "Некоректний формат телефону",
    bi_validation_Website: "Некоректний формат веб-сайту",
    bi_first_Name: "Ім'я",
    bi_last_Name: "Прізвище",
    bi_confirm_email: "Адреса електронної пошти не підтверджена",
    bi_resend_email: "Надіслати email для підтвердження повторно",
    bi_resend_email_success: "Email для підтвердження було надіслано повторно",
    bi_change_password: "Змінити пароль",
    bi_set_password: "Встановити пароль",
    bi_cancel_password: "Скасувати зміну пароля",
    bi_current_password: "Діючий пароль",
    bi_retype_password: "Повторіть новий пароль",
    bi_new_password: "Новий пароль",
    bi_save_password: "Зберегти новий пароль",
    bi_password_change_success: "Пароль успішно зміненно",
    bi_confirm_new_password: "Підтвердіть пароль",
    own_use_w3w: "Використовувати what3words для геолокації",
    own_email_Confim: "Будь ласка, підтвердіть Вашу електронну адресу",
    own_anyConnectedPlace: "У вас ще немає жодного пов’язаного місця",
    own_myQuestions: "Мої запитання",
    own_createQuestion: "Створити запитання",
    own_orderStickers: "Замовити наклейки",
    own_selectRange: "Виберіть діапазон",
    own_today: "Сьогодні",
    own_last7days: "Останні 7 днів",
    own_lastMonth: "Минулого місяця",
    own_allTime: "Весь час",
    own_custom: "Персональний",
    own_Search: "Пошук",
    own_showMore: "Показати більше",
    own_showLess: "Показати менше",
    own_Locations: "Місцезнаходження",
    own_Questions: "Запитання",
    own_Total: "Всього",
    own_Happy: "Супер",
    own_SoSo: "Так собі",
    own_Sad: "Погано",
    own_green: "Зелений",
    own_yellow: "Жовтий",
    own_red: "Червоний",
    own_EditQuestion: "Редагувати питання",
    own_DownloadPDF: "Завантажити PDF",
    own_DownloadPDFMobile: "Завантажити PDF",
    own_OrderSticker: "Замовити наклейку",
    own_DeleteQuestion: "Видалити запитання",
    own_DownloadAndPrint: "Завантажити та роздрукувати",
    own_OrderStickerFrom: "Замовити наклейку від AirVote",
    own_DeliveryAddress: "Введіть адресу доставки",
    own_RecipientName: "Ім'я одержувача",
    own_RecipientPhone: "Телефон одержувача",
    own_RecipientEmail: "Email одержувача",
    own_Comment: "Коментар",
    own_ShowZeroVotes: "Питання без відгуків",
    own_CreateNew: "Створіть нове запитання AirVote",
    own_EnterQuestion: "Введіть тут своє питання AirVote",
    own_SpecifyLocation: "Вкажіть місцезнаходження",
    own_DownloadPDF_Title: "Ви успішно додали запитання!",
    own_DownloadPDF_Description: "Тепер ви можете завантажити PDF наклейки на запитання",
    own_DownloadPDF_EditTitle: "Ви успішно відредагували питання!",
    own_SureTODelete: "Ви впевнені, що хочете видалити своє запитання?",
    own_DownloadSticker: "Завантажити стікер в PDF",
    own_StickerProportion: "Виберіть макет наклейки, який відповідає вашим потребам",
    own_PanelTextLeaflet: "Компакт",
    own_PanelTextBusiness: "Візитка",
    own_PanelTextExtended: "Стандарт",
    own_PanelSubtitleLeaflet: "Роздрукуйте як невелику рекламну картку для клієнтів або помістіть її на зворотному боці візитної картки",
    own_PanelSubtitleExtended: "Роздрукуйте у вигляді наліпки або листівки. Розмістіть їх в межах досяжності клієнтів",
    own_PanelSubtitleBusiness: "Більш компактний дизайн для друку та розповсюдження у вигляді візитних карток",
    own_AllVotesWillDeleted: "Усі відгуки, пов'язані з цим запитанням AirVote будуть видалені",
    own_HasBeenDeleted: "Ваше запитання видалено",
    own_DontForgetCreate: "Не забудьте створити новий!",
    own_Manage: "Керування",
    own_Title: "Ласкаво просимо на бізнес-панель AirVote!",
    own_Business: "Ваш бізнес",
    own_Subitle: "Вкажіть назву вашого бізнесу, щоб створювати питання. Її можна буде змінити\nв будь-який момент",
    own_BusinessName: "Назва вашого бізнесу",
    own_SaveBtn: "Зберегти і продовжити",
    own_SaveBtnWithQuestion: "Зберегти та отримати мої QR-смайлики",
    own_CanNotFind: "Не можу знайти свій бізнес",
    own_PleaseStartWriting: "Почніть вводити назву своєї компанії та виберіть її з випадаючого списку",
    own_Address: "Адреса",
    own_AssetId: "Ідентифікатор",
    AnalyticSettings: "Налаштування аналітики",
    AnalyticDescription: "Спосіб відображення даних на бізнес-панелі",
    AnalyticIndex: "Індекс аналітики",
    AnalyticWhatMean: "Що це означає?",
    AnalyticWhatMeanIndex: "Чому Index - це гарна ідея?",
    AnalyticWhatMeanIndexDescription: "Index забезпечує об'єктивний показник для відстеження тенденцій у часі та порівняння показників у різних сферах",
    AnalyticWhatMeanIndexValue: "Як AirVote обчислює значення Index:",
    AnalyticIndexPromouterScore: "・ Чистий бал промоутера: # \"щасливі голоси\" * 100% + # \"так собі\" голоси * 0% - # \"сумні\" голоси * 100%. Найвищий бал - 100. Найнижчий - 100.",
    AnalyticIndexAirVoteScore: "・ Оцінка AirVote: # ”щасливих голосів * 100% + #” так собі ”голосів * 50%. Найвищий бал - 100. Найнижчий - 0.",
    ThereIsAnError: "Введіть правильне значення",
    StickerStatus: "Статус стікера",
    Requested: "Запит відправлено",
    Sent: "Надісланий",
    Cancelled: "Скасований",
    Close: "Закрити",
    welcomeModalTitle: "Знайдіть вашу компанію або бізнес на карті",
    welcomeModalSubtitle: "Ми використовуємо дані Google, щоб допомогти вам зареєструвати свою компанію в AirVote",
    welcomeModalSearchYouBusinass: "Шукайте свою команію за допомогою поля для вводу вгорі екрану",
    welcomeModalPickOnMap: "Або виберіть його на карті",
    welcomeModalNotOnGoogle: "Якщо вашої компанії або бізнесу нема на карті - пишіть нам на пошту",
    mapTipsSearch: "Шукайте свою команію або бізнес за назвою",
    mapTipsPick: "Або виберіть його на карті",
    OK: "OK",
    Location: "Місцезнаходження",
    Question: "Питання",
    thankVoteTitle1: "Ваш відгук успішно збережено",
    thankVoteTitle2_1: "Дякуємо за ваш відгук",
    thankVoteTitle2_2: "Увійдіть в AirVote, щоб ви могли переглянути та змінити свої голоси",
    companyManagement: "Управління компанією",
    sites: "Відділення",
    site: "Відділення",
    SitesDescription: "Відділення - це різні філії чи офіси вашої компанії. Відділення може бути призначено для одного або декількох менеджерів відділень. Ці менеджери можуть редагувати дані про відділення та мати доступ до аналітики відділення",
    addNewSite: "Додати відділення",
    siteDetail: "Деталі відділення",
    questionsAndAnalytics: "Питання та аналітика",
    companyInformation: "Інформація про компанію",
    companyManagers: "Менеджери компанії",
    saveChanges: "Зберегти зміни",
    companyManagersDescription: "Ви можете призначити менеджерів компанії, які зможуть редагувати будь-які дані компанії, а також керувати відділеннями, призначати менеджерів відділень та інших менеджерів компанії",
    Invite: "Запросити",
    EnterEmailToAssignCompanyManager: "Введіть email менеджера",
    enterSeveralEmailByComma: "Ви можете ввести кілька адрес електронної пошти, розділених комою",
    Pending: "Очікування",
    Accepted: "Прийнято",
    Remove: "Видалити",
    ActiveManagers: "Активні менеджери",
    NoOthersCompanyManagersAssigned: "Не призначено інших керівників компаній",
    removeManager: "Видалити менеджера: {v1}?",
    all: "Всі",
    editManagers: "Редагувати менеджерів",
    assignManagers: "Призначте менеджерів",
    viewAnalytic: "Перегляньте аналітику",
    deleteSite: "Видалити відділення",
    deleteSiteConfirm: "Видалити відділення: {v1}?",
    siteManagers: "Менеджери відділень",
    SiteManagersNotAssigned: "Не призначені",
    siteName: "Назва відділення",
    siteAddress: "Посилання на ваш веб-сайт або соцмережі",
    siteAddressSidebar: "Адрес",
    Website: "Вебсайт",
    Email: "Email",
    Alias: "Алiас",
    EditPhoto: "Редагувати фото",
    SitePhoto: "Фото відділення",
    AirVoteSuggestsTitle: "AirVote пропонує",
    SearchForQuestion: "Запропоновані питання",
    UseQuestion: "Використати це питання",
    ImagesSupportedParams: "Підтримуються зображення у форматах PNG та JPG. Максимальний розмір фотографії - 5 Мб",
    UploadFile: "Завантажити файл",
    RemovePhoto: "Видалити фотографію",
    RemovePhotoConfirm: "Ви впевнені, що хочете видалити фотографію відділення?",
    RemovePhotoSuccess: "Фотографію успішно видалено",
    WrongFormat: "Неправильний формат. Підтримуються формати PNG та JPG",
    PhotoOverweight: "Фото більше ніж {v1}Мб",
    cancelInvite: "Скасувати запит: {v1}?",
    createSiteMap: "Створити нове відділення, використовуючи це місце: {v1}?",
    chooseNewPlaceFrOrganization: "Будь ласка, оберіть нове відділення для вашої організації",
    MyBusinessIsMultipleSites: "Мій бізнес має кілька відділеннь",
    goingToMultipleSitesMode: "Ви збираєтесь подати запит на кілька відділеннь для вашої організації",
    by_questions: "Питанням",
    by_sites: "Відділенням",
    by_locations: "Місцезнаходженнями",
    groupBy: "Групувати за",
    Diagram: "Діаграма",
    ID: "ID",
    Filter: "Фільтр",
    Comments: "Коментарі",
    ownLastVotes: "Останні відгуки",
    IndexAirvote: "Індекс AirVote",
    TotalVotes: "Всього",
    Notifications: "Повідомлення",
    CloseAccount: "Закрити мій акаунт",
    DowngradeToClient: "Понизити мій акаунт до клієнта",
    SendNotificationEach2: "відгуків",
    WithCommentsOnly: "з коментарями/фото/аудіо",
    CommentsOnly: "Тільки коментарі",
    SMS: "СМС",
    Reports: "Звіти",
    daily: "Щодня",
    weekly: "Щотижня",
    monthly: "Щомісяця",
    SendRequestToClose: "Відправити запит на закриття аккаунту?",
    SendRequestToRestore: "Надіслати запит на відновлення аккаунту?",
    RestoreAccount: "Відновити аккаунт",
    ReturnBtn: "Назад",
    DowngradeProfileToClient: "Понизити акаунт до ролі клієнта?",
    ProfileSettings: "Налаштування профілю",
    savedSuccessfuly: "Збережено успішно",
    Message: "Повідомлення",
    sendAlertEvery: "Надсилати сповіщення кожні",
    checkboxSoSo: "Так собі",
    checkboxHappy: "Добре",
    checkboxSad: "Погано",
    NoData: "Немає даних",
    Decline: "Відхилити",
    Approve: "Ухвалити",
    DeclineRequest: "Відхилити запит на видалення акаунту?",
    ApproveRequest: "Ухвалити запит на видалення акаунту?",
    MyPlaces: "Мої місця",
    EmptySiteTitle: "У вашій компанії немає відділень. Додайте перше!",
    EmptySiteDescription: "Відділення - це різні філії чи офіси вашої компанії. Відділення можна призначити одним або декількома менеджерами відділень. Ці менеджери можуть редагувати дані про відділення та мати доступ до аналітики відділень",
    accountSettings: "Налаштування аккаунта",
    accountSettingsDescription: "Змініть дані свого профілю, керуйте сповіщеннями та звітами",
    otherOptions: "Інші варіанти",
    UploadNewPhoto: "Завантажте нову фотографію",
    receiveBadVotesViaSms: "Ви можете отримувати сповіщення про відгуки по SMS чи Email",
    Threshold: "Поріг",
    SoSoVotes: "Так собі відгуки",
    Channel: "Канал",
    DisableAllNotifications: "Вимкнути всі сповіщення",
    EnableAllNotifications: "Вимкнути всі сповіщення",
    sendDetailedReportToEmail: "Ми можемо надсилати детальні звіти на Вашу електронну адресу",
    Regularity: "Регулярність",
    nothingSelected: "Нічого не вибрано",
    allNotificationsDisabled: "Усі сповіщення вимкнено",
    createNewUser: "Створити нового користувача",
    exportRawData: "Експортувати",
    exportTo: "Експортувати в",
    w3wTitle: "Простий спосіб описати місце розташування в будь-якій точці світу",
    w3wLearnMore: "Дізнатися більше",
    unassignedQuestion: "Фільтрувати непризначені запитання",
    moreOptiosPopuoTitle: "Інші опції",
    tab_Map: "Карта",
    driverMainText: "У вашого профілю {v1} є доступ тільки для управління місцями розміщення і місцями розташування.\n" +
        "Використовуйте свій логін для управління, щоб отримати повний доступ до панелі управління {v2}",
    own_filter_placeholder: "Введіть для пошуку",
    own_ExtPlacementEdit: "Редагувати",
    question_suggestions_freq_title: "Останні використані",
    smileysMailTitle: "Ваші смайлики AirVote QR вже відправлені!",
    smileysMailSubtitle: "Перевірте {v1} - QR-смайлики вже там. Якщо ви не отримаєте їх протягом декількох хвилин - перевірте папку \"Спам\" або",
    smileysMailDownload: "завантажте їх тут",
    smileysMailChecklist: "Тепер ви можете увійти в свою бізнес-панель. Там ви можете:",
    smileysMailChecklistFirst: "Переглядати звіти про відгуки клієнтів в режимі реального часу",
    smileysMailChecklistSecond: "Створити та роздрукувати додаткові запитання",
    smileysMailChecklistThird: "Налаштувати сповіщення",
    smileysMailChecklistFourth: "Переглянути детальну статистику",
    smileysMailChecklistMore: "...та багато іншого!",
    smileysMailChecklistBtn: "Перейти в бізнес панель",
    smileysMailChecklistBack: "Повернутися на веб-сайт",
    signIn_enter: "Увійдіть, використовуючи",
    signIn_or: "або",
    signIn_difficulties: "Маєте труднощі?",
    signIn_contact: "Звертайтесь до нас за адресою",
    signIn_signIn_title: "Вхід",
    signIn_signUp_title: "Реєстрація",
    signIn_enter_using_email: "або увійдіть, використовуючи email",
    signIn_email_hint: "Email",
    signIn_password_hint: "Пароль",
    signIn_signInBtn: "Увійти",
    signIn_forgotPass_btn: "Забули пароль?",
    signIn_noCreditReq: "Платіжні дані не потрібні",
    signIn_firstName_hint: "Ім\'я",
    signIn_lastName_hint: "Прізвище",
    signIn_signUp_btn: "Створити акаунт",
    signIn_useMedia: "Або зарєструйтеся через соцмережі",
    signIn_agreeTo: "Я приймаю",
    signIn_tAndC: "Умови використання",
    signIn_recoverPassword: "Відновлення пароля",
    signIn_recoverPassSubtitle: "Введіть email, який було використано при реєстрації",
    signIn_recoverPassContinue: "Продовжити",
    signIn_recoverPassBack: "На сторінку входу",
    signIn_codeAlreadyUsed: "Цей код скидання пароля вже використованно",
    signIn_protected: "Цей сайт захищений reCAPTCHA та Google і застосовуються",
    signIn_privacyPolice: "Політика конфіденційності",
    signIn_and: "та",
    signIn_Terms: "Умови використання.",
    signIn_Login: "Увійти через {v1}",
    signIn_Register: "Реєстрація через {v1}",
    signIn_RegisterWithEmail: "Зареєструйтесь за допомогою електронної пошти",
    signIn_RegisterWithQuestion: "Далі: Про мій бізнес",
    signIn_SeparatorText: "АБО",
    signIn_TitleWithQuestion: "Зареєструйтесь у AirVote, щоб:",
    signIn_ChecklistFirst: "Отримати QR-смайлики електронною поштою",
    signIn_ChecklistSecond: "Отримати доступ до панелі бізнесу для відстеження відгуків",
    signIn_LookAtEmail: "Будь ласка, перегляньте свою електронну адресу для отримання детальної інформації",
    resetPasswordRequestCancel: "Ваш запит на скидання пароля скасовано",
    resetPasswordRequestAlreadyCanceled: "Скидання пароля вже скасовано",
    changePasswordFormTitle: "Форма зміни паролю",
    passwordDontMatch: "Паролі не збігаються",
    auth_confirm_email_confirming: "Підтвердження email'у 🔄",
    auth_confirm_email_confirmed: "Email підтверджено ✅\nПерехід в бізнес-панель...",
    auth_confirm_email_already_confirm: "Ваша електронна адреса вже підтверджена",
    login_btn_link: "Увійдіть",
    login_btn_text: "до вашої бізнес-панелі",
    giveawayBottom_title: "Натисніть, щоб взяти участь у розіграші подарункових карток!",
    giveawayBottomFinish_title: "Вас додали до розіграшу подарункової картки!",
    giveawayPopup_title: "БЕРІТЬ УЧАСТЬ У РОЗІГРАШІ ПОДАРУНКОВОЇ КАРТОЧКИ",
    giveawayPopup_login: "Увійдіть через Google або Facebook",
    giveawayPopup_review: "Залиште відгук на будь-якій зі cторінок {v1}",
    giveawayPopup_entered: "Ви будите приймати участь в розіграші",
    giveawayPopup_BtnLogin: "Почніть з входу в",
    giveawayPopup_BtnReview: 'Залиште відгук',
    giveawayPopup_cancel: 'Я не хочу брати участь',
    giveawayPopup_finalStep: 'Ми вдячні за ваш чесний відгук!\n\nВас додали до нашого розіграшу.\n\nПовертайтеся і голосуйте ще раз: кожен голос збільшить ваші шанси!',
    giveawayPopup_proceedReview: "Перейти до відправки відгука",
    password_validation_min_length: "Мінімум 6 символів",
    password_validation_uppercase: "Одна велика літера",
    password_validation_lowercase: "Одна маленька літера",
    loadPdfProgress: "Створення PDF 🔄",
    showManagePopupTitle: "Керуйте питаннями, завантажуйте QR-смайлики",
    showManagePopupSubtitle: "Ласкаво просимо до бізнес-панелі AirVote! Кожен блок, який ви бачите на екрані, - це питання, яке ви створили. Використовуйте іконку для керування питаннями: редагуйте, видаляйте або завантажуйте QR-смайлики у форматі PDF",
    showFeedbackPopupTitle: "Почніть отримувати відгуки",
    showFeedbackPopupSubtitle: "Коли ви отримаєте QR-смайлики, розмістіть їх у такому місці, щоб їх бачили клієнти. Кожен відгук негайно відображається на панелі вашого бізнесу",
    showAlertsPopupTitle: "Налаштуйте та отримуйте сповіщення",
    showAlertsPopupSubtitle: "Вітаємо з отриманням перших відгуків! Чи знаєте ви, що можете отримувати сповіщення про будь-який відгук по СМС та електронною поштою? Перейдіть на сторінку свого профілю, щоб налаштувати сповіщення",
    helpCenterTitle: "Центр допомоги",
    dataReportPopup: "Дані відсутні. Оберіть інший діапазон дат",
    dataReportPopupMobileXLSX: 'Цей файл буде містити лише основні дані. Для перегляду детальної аналітики та діаграм голосування, будь ласка, використовуйте інформаційну панель AirVote на ПК або Mac',
    unsubscribeBtn: "Відписатися",
    unsubscribeSaveBtn: "Зберегти налаштування",
    unsubscribePopupText: "Ви успішно відписалися",
    orderBannerSubtitle: "Ми можемо роздрукувати ваші запитання на водонепроникному вінілі та надіслати їх у будь-яку точку світу",
    orderBannerBtn: "Замовити стікери",
    orderStickersBtn: "Замовити QR-стікери",
    orderPageBtn: "Давайте розпочнемо",
    orderSelectTitle: "Виберіть питання, які ви хочете надрукувати",
    orderBusinessSite: 'Відділення',
    orderBusinessPlacement: 'Місцезнаходження',
    orderTotal: 'Загальна сума замовлення',
    orderDelivery: 'Доставка',
    orderDeliveryText: 'Безкоштовно',
    orderFormTitle: 'Завершіть ваше замовлення',
    orderFormSubtitle: 'Орієнтовний час доставки - 10—15 днів',
    orderShippingTitle: 'Доставка за межі США та Європи',
    orderShippingSubtitle: 'Зв’яжіться з AirVote, щоб отримати ціну замовлення, включаючи всі збори за доставку',
    orderQuote: 'Розрахувати вартість',
    orderSuccessPayment: 'Ваше замовлення успішно створено. Незабаром ми зв’яжемося з вами та надамо вартість замовлення.',
    orderSuccessPayPal: 'Ваше замовлення оплачено. Наша команда опрацює його та зв’яжеться з вами найближчим часом.',
    orderBtnToDashboard: 'Перейти на бізнес-панель',
    orderShippingBlockTitle: 'Інформація про доставку',
    orderCountryLabel: 'Країна',
    orderStickerSizeLabel: 'Розмір стікерів',
    own_votesNotFound: 'У вас відсутні нещодавні відгуки 😔\n\nБудь ласка, перевірте, що ваші запитання AirVote розміщені на місцях  ',
    own_votesQuestion: 'Питання:',
    own_votesPlacement: 'Місце:',
    own_votesPriorVotes: 'Попередні відгуки клієнта (приблизно):',
    own_votesUser: 'Користувач:',
    own_votesComment: 'Коментар:',
    own_votesContactInfo: 'Контактні дані:',
    bulkPlacement: 'Групове редагування місцезнаходження',
    bulkPlacementPopupSavedQuestions: 'Обрано запитань',
    bulkPlacementPopupSelectAll: 'Обрати усі',
    bulkSuccessfulPlaceEdit: "Місцезнаходження змінено",
    bulkInputPlaceHolder: "Нове місцезнаходження",
    manageNotEnoughPermissions: "У вас недостатньо прав для керування цим запитанням. Будь ласка, увійдіть з іншого акаунта або запросіть доступ для редагування",
    showAllVotes: "Показати всі останні відгуки",
    setupTelegramBtn: "Налаштувати Telegram Bot",
    copy: "Копіювати",
    telegramPopupGroup: "Додати бота в групу",
    telegramPopupPrivate: "Додати бота в приватний чат",
    telegramPopupTitle: "Ваш Хеш",
    telegramHashAvailable: "Поточний хеш доступний протягом 1 години",
    emailSignature: 'Електронні комунікації',
    emailSignatureSubtitle: "Скопіюйте/вставте смайли у свої електронні листи, електронні рахунки або для будь-яких онлайн-презентацій",
    emailSignatureTitle: 'Як AirVote працює для вас?',
    emailSignatureClick: 'Натисніть на смайлик, щоб залишити відгук',
    emailSignatureCopyLink: 'Копіювати посилання',
    singleEmailSignaturePageTitle: 'Додайте AirVote E-Smiley до ваших комунікацій',
    copied: 'Скопійовано',
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Service Log',
    airLeadSubmittedBy: 'Представлений:',
    airLeadChooseDriver: 'вибрати водія',
    airLeadCompanyName: 'Назва компанії',
    airLeadSiteType: 'Тип сайту',
    airLeadOpportunity: 'Можливість',
    airLeadCustomer: 'Клієнт',
    airLeadAdditionalNotes: 'Додаткові нотатки',
    airLeadMoreService: 'Більше послуг',
    airLeadMoreUnits: 'Більше одиниць',
    airLeadSink: 'Раковина',
    airLeadCallThem: 'Позвонить им',
    airLeadSubmitALead: 'Відправити заявку',
    airLeadHideLeads: 'Приховати закриті заявки',
    airLeadShowAllLeads: 'Показати всі заявки',
    airLeadDashboardDate: 'Дата',
    airLeadDashboardType: 'Тип',
    airLeadDashboardStatus: 'Статус',
    airLeadDashboardStatusNotes: 'Примітки щодо статусу',
    airLeadDashboardLastActionDate: 'Дата останньої дії',
    airLeadDashboardActionBy: 'Дії були зроблені',
    airLeadDashboardSalesFollowUp: 'Відстеження продажів',
    airLeadDashboardNotClosed: 'Не закрито',
    airLeadDashboardClosedWon: 'Закрито/Виграно',
    airLeadDashboardNotQualified: 'Некваліфікований',
    airLeadDashboardCommission: 'Комісія',
    airLeadDashboardNotLeadsFound: 'Нічого не знайдено',
    airLeadDashboardRefresh: 'Оновити',
    airLeadInfoPopupDriver: 'Водій',
    airLeadInfoPopupNotes: 'Примітки',
    airLeadInfoPopupLocation: 'Місце розташування',
    airLeadInfoPopupViewOnMap: 'Подивитись на карті',
    airLeadInfoPopupServices: 'Послуги',
    airLeadStatusAndCommissionError: 'Будь ласка, введіть статусні примітки та комісію, щоб закрити угоду',
    airLeadStatusNotesError: 'Будь ласка, введіть примітки до статусу, щоб закрити угоду',
    airLeadNewCustomerLead: 'Новий клієнт',
    airLeadExistingCustomer: 'Существующий клієнт',
    airLeadPleaseChooseDriver: 'Будь ласка, виберіть водія',
    airLeadPleaseCompanyInfo: 'Будь ласка, введіть інформацію про компанію',
    airLeadPleaseCustomerInfo: 'Будь ласка, введіть інформацію про клієнте',
    airLeadGoodLack: 'Удачи на вашому шляху! \nСпасибі за допомогу в привлеченні нових клієнтів!',
    airLeadCommission: 'Комісія має бути більше 0',
    airLeadNumberShouldContains: 'Число має містити менше 3 цифр',
    sldPlaceGuid: "Гуид місцязнаходження",
    sldOrganizationGuid: 'Гуид організації',
    sldGetPlaceConfig: 'Перезавантажити конфігурацію',
    sldEnableDetails: 'Увімкнути деталі проблеми',
    sldBasicConfig: 'Базова конфігурація',
    sldScreenTitle: 'Заголовок екрану',
    sldScreenSubTitle: 'Підзаголовок екрану',
    sldScreenBackground: 'Колір заднього фону:',
    sldMaxCount: 'Максимальна кількість вибраних елементів',
    sldEnterForUnlimited: 'Введіть 0 для необмеженої кількості',
    sldShowComment: 'Завжди показувати коментар',
    sldBlocks: 'Блоки:',
    sldText: 'Текст',
    sldGreenScreen: 'Зелений екран',
    sldYellowScreen: 'Жовтий екран',
    sldRedScreen: 'Червоний екран',
    sldOverrideSettings: 'Перезаписати базові налаштування',
    sldOverrideBlocks: 'Перезаписати базові блоки',
    sldSecondLevelDetails: 'Деталі другого рівня',
    configMissingMsg: 'Конфіг відсутній, бажаєте його вімкнути?',
    sldTakeFromPlace: 'Зняти з відділення',
    sldChooseAnIcon: 'Виберіть іконку',
    sldEditIcon: 'Редагувати іконку',
    sldUploadIcon: 'Завантажити нову іконку',
    sldIconTag: 'Тег іконки',
    sldPleaseFillInput: 'Будьласка заполніть поле',
    sldDefaultText: 'Текст за умовчанням',
    sldChooseIcon: 'Будьласка оберіть іконку',
    sldSaveAndAddMore: 'Зберегти та продовжити',
    sldAddIcon: 'Додати іконку',
    sldAreYouSure: "Ви хочете видалити цю іконку?",
    enableServiceLog: 'Увімкнути журнал обслуговування',
    serviceLogRequirePin: 'Потрібен пін-код?',
    serviceLogInfoPopup: 'Показати спливаюче вікно з інформацією про журнал обслуговування',
    serviceLogPlacementEdit : 'Показати редагування місцязнаходження',
    commentViewOnMap: 'Подивитись на карті',
    own_limitedAccessDialogTitle: "Обмежений доступ",
    own_limitedAccessDialogBody: "Кількість ваших відгуків перевищила ліміт безкоштовного тарифа на місяць. Відгуків недоступно: {v1}.\nДля отримання повного доступу, зв'яжіться з командою AirVote",
    own_limitedAccessDialogContactBtn: "Зв\'язатися",
    own_limitedAccessText: "Кількість ваших відгуків перевищила ліміт безкоштовного тарифа на місяць. Відгуків недоступно: {v1}.\nДля отримання повного доступу, зв'яжіться з командою AirVote: {v2}",
    sldTagInUseErrorTitle: "Неможливо виконати. Тег наразі використовується:",
    tab_AssetsMap: "Карта вбиралень",
    settings_checkbox_GoogleReviewAlerts: "Сповіщення про Google відгуки",
    saving: "Збереження",
}
